import { SaIconsType } from '~/assets/ts/types/icons'
import { MulticastPlatform } from '~/apiclient/apiwebcasts'
import { SermonSocialSharingPlatform } from '~/apiclient/apisermons'
import {
  FacebookAccountApi,
  GoogleAccountApi,
  TwitterAccountApi,
} from '~/apiclient/apibroadcasters'

export interface SocialPlatformInfo {
  title: string
  icon: SaIconsType
  textColorClasses: string
}

const GenericPlatform = {
  title: 'Untitled',
  icon: 'broadcast',
  textColorClasses: '',
} as SocialPlatformInfo

export function GetSocialPlatformInfo(
  platform: SermonSocialSharingPlatform | MulticastPlatform
): SocialPlatformInfo {
  switch (platform) {
    case SermonSocialSharingPlatform.Google:
    case MulticastPlatform.YoutubeApi:
    case MulticastPlatform.Youtube:
      return {
        title: 'YouTube',
        icon: 'youtube-brands',
        textColorClasses: 'text-brand-youtube',
      }
    case SermonSocialSharingPlatform.Facebook:
    case MulticastPlatform.FacebookApi:
    case MulticastPlatform.Facebook:
      return {
        title: 'Facebook',
        icon: 'facebook-brands',
        textColorClasses: 'text-brand-facebook',
      }
    case SermonSocialSharingPlatform.Twitter:
    case MulticastPlatform.Twitter:
    case MulticastPlatform.TwitterApi:
      return {
        title: 'X (Twitter)',
        icon: 'x-twitter-brands',
        textColorClasses: 'text-brand-x-twitter dark:text-white',
      }
    case MulticastPlatform.SermonAudio:
      return {
        ...GenericPlatform,
        title: 'SermonAudio',
      }
    case MulticastPlatform.Twitch:
    case MulticastPlatform.Other:
    default:
      return GenericPlatform
  }
}

export interface SocialPlatformAccountInfo {
  name: string
  url: string
}

export function GetFacebookAccountInfo(
  config: FacebookAccountApi
): SocialPlatformAccountInfo | undefined {
  const id = config.facebookPublishGroupID || undefined
  if (!id) return undefined
  return {
    name: config.pageName || config.name || '',
    url: `https://www.facebook.com/${id}`,
  }
}

export function GetGoogleAccountInfo(
  config: GoogleAccountApi
): SocialPlatformAccountInfo | undefined {
  const { name, youtubeChannelURL } = config
  if (!name) return undefined
  return {
    name: name || '',
    url: youtubeChannelURL || '',
  }
}

export function GetTwitterAccountInfo(
  config: TwitterAccountApi
): SocialPlatformAccountInfo | undefined {
  const { name } = config
  if (!name) return undefined
  return {
    name: name ? `@${name}` : '',
    url: `https://www.x.com/${name}`,
  }
}

export function CanUseFacebookIntegration(config?: FacebookAccountApi) {
  if (!config) return false
  const info = GetFacebookAccountInfo(config)
  if (!info) return false
  return config.permissions.includes('publish_video')
}

export function CanUseGoogleIntegration(config?: GoogleAccountApi) {
  if (!config) return false
  const info = GetGoogleAccountInfo(config)
  if (!info) return false
  return config.scopes.includes('youtube.force-ssl')
}
